import {
  ParametryPrzedmiotuSzklanego,
  ParametryUszkodzen,
  ParametryZbioruUszkodzen,
  Uszkodzenie,
  ZbiorUszkodzen
} from '../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {aktualizujZbiorUszkodzen} from '../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen.actions';
import {Store} from '@ngrx/store';
import {ActivatedRoute} from '@angular/router';
import {NavigationService} from '../../../../../../shared/services/navigation/navigation.service';
import {
  FormularzUszkodzenService
} from '../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import {SlownikService} from '../../../../../../shared/services/slownik/slownik.service';
import {v4 as uuidv4} from 'uuid';
import {LokalizacjaUszkodzenia} from '../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';
import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {YearMonth} from '../../../../../../shared/components/ui/datepicker/datepicker-yearmonth.component';
import {FormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {isDateFilled, isInteger, max, min} from '../../../../../../shared/validators/ControlValidators';
import {SlownikUszkodzen} from '../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {ElementUszkodzenia} from '../../../../../../shared/services/slownik/types/element-uszkodzenia';
import {selectZbiorUszkodzenById} from '../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen.selectors';
import {SlownikRodzajElementu} from '../../../../../../shared/model/rodzaj-elementu/slownikRodzajElementu';
import {RodzajElementu} from '../../../../../../shared/services/slownik/types/rodzaj-elementu';
import {
  czyDataRemontuWymaganaSelector
} from '../../../../../../shared/store/samoobsluga/przedmioty/przedmioty-selectors';
import {UszkodzeniaWLokalizacjiComponent} from "../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/lokalizacja/uszkodzenia-w-lokalizacji.component";

@Component({
  selector: 'app-base-uszkodzenia-component',
  template: ``
})
export abstract class BaseLokalizacjaUszkodzenComponent implements OnInit, OnDestroy {

  readonly MIN_VALUE: number = 1
  readonly MAX_VALUE: number = 10
  readonly LICZBA_POCZATKOWYCH_USZKODZEN: number = 5;

  public idZbioruUszkodzen!: string;
  public idPrzedmiotuUbezpieczenia!: number;
  public formularzLokalizacjiUszkodzenia!: UntypedFormGroup;
  public listaDostepnychUszkodzen: ElementUszkodzenia[] = [];
  public czyWprowadzoneUszkodzeniaSaPoprawne = false;
  private routeSubscription!: Subscription;
  private subskrypcjaLokalizacjiUszkodzenia!: Subscription;
  protected zbiorUszkodzenSubscription!: Subscription;
  protected zbiorUszkodzen: ZbiorUszkodzen | undefined;
  public czyDataRemontuWymagana!: boolean | undefined;
  public sortujUszkodzeniaWgPriorytetowWyswietlania = true;

  @Output()
  aktualizacjaWalidacjiFormularza = new EventEmitter<boolean>()

  constructor(public route: ActivatedRoute, public store: Store, public navigation: NavigationService,
              public formularzUszkodzenService: FormularzUszkodzenService,
              protected slownikService: SlownikService) {
  }

  abstract zapiszUszkodzeniazPodformularzy(): void;

  abstract iniciujFormularz(): void;

  abstract get slownikUszkodzen(): SlownikUszkodzen[];
  abstract get lokalizacjaUszkodzen(): LokalizacjaUszkodzenia;

  ngOnInit(): void {
    this.routeSubscription = this.route.queryParams.subscribe(params => {
      // pobieramy idPrzedmiotu z url, dlatego musimy zrzutować z string na number
      this.idPrzedmiotuUbezpieczenia = +params.idPrzedmiotu;
      this.idZbioruUszkodzen = params.idZbioruUszkodzen;
    });
    this.pobierzSlownikUszkodzonychElementow();
    this.store.select(czyDataRemontuWymaganaSelector, this.idPrzedmiotuUbezpieczenia).subscribe(czyDataRemontuWymagana => {
      this.czyDataRemontuWymagana = czyDataRemontuWymagana
    }).unsubscribe()
    this.iniciujFormularz();
    this.inicjujIstniejaceUszkodzeniaDoEdycji();
    this.formularzUszkodzenService.czyFormularzJestPoprawny.subscribe(
      value => this.czyWprowadzoneUszkodzeniaSaPoprawne = value
    );
    if (this.formularzLokalizacjiUszkodzenia) {
      this.subskrypcjaLokalizacjiUszkodzenia = this.formularzLokalizacjiUszkodzenia.valueChanges
        .subscribe(() => {
          this.formularzUszkodzenService.formularzLokalizacjiUszkodzenia = this.formularzLokalizacjiUszkodzenia;
          this.aktualizacjaWalidacjiFormularza.emit(this.formularzLokalizacjiUszkodzenia.valid);
        });
    }
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.formularzUszkodzenService.przywrocStanPoczatkowyFormularza();
    if (this.zbiorUszkodzenSubscription) this.zbiorUszkodzenSubscription.unsubscribe();
  }

  protected pobierzSlownikUszkodzonychElementow(): void {
    this.slownikService.pobierzElementyUszkodzen(this.slownikUszkodzen, this.sortujUszkodzeniaWgPriorytetowWyswietlania)
      .subscribe(value => this.listaDostepnychUszkodzen = value)
  }

  protected pobierzSlownikRodzajuElementow(slownikRodzajuElementu: SlownikRodzajElementu, observer: {next: (rodzajElementu: RodzajElementu) => void }): void {
    this.slownikService.pobierzRodzajElementu(slownikRodzajuElementu)
    .subscribe(observer)
  }

  protected utworzLubAktualizujZbiorUszkodzen<N extends ParametryUszkodzen>(parametryZbioruUszkodzen: ParametryZbioruUszkodzen, uszkodzenia: Uszkodzenie<N>[]): void {
    const zbiorUszkodzen = {} as ZbiorUszkodzen
    zbiorUszkodzen.id = (this.idZbioruUszkodzen) ? this.idZbioruUszkodzen : this.generateUuId();
    zbiorUszkodzen.lokalizacja = this.lokalizacjaUszkodzen.name;
    zbiorUszkodzen.opisLokalizacji = this.lokalizacjaUszkodzen.label;
    zbiorUszkodzen.parametry = parametryZbioruUszkodzen;
    zbiorUszkodzen.uszkodzenia = uszkodzenia;
    this.save(zbiorUszkodzen);
  }

  protected inicjujIstniejaceUszkodzeniaDoEdycji(): void {
    if (this.idZbioruUszkodzen) {
      this.zbiorUszkodzenSubscription = this.store.select(selectZbiorUszkodzenById, this.idZbioruUszkodzen).subscribe(
        (zbiorUszkodzen) => {
          this.zbiorUszkodzen = zbiorUszkodzen
          if (zbiorUszkodzen) {
            this.formularzUszkodzenService.ustawIstniejaceUszkodzenia(zbiorUszkodzen.uszkodzenia);
            if (this.formularzLokalizacjiUszkodzenia && this.czyDataRemontuWymagana) {

              this.formularzLokalizacjiUszkodzenia.controls.dataRemontu.setValue(zbiorUszkodzen.parametry.dataRemontu);
            }
          }
        }
      )
    }
  }

  protected utworzUszkodzeniaPojedyncze<N extends ParametryUszkodzen>(uszkodzenia: UszkodzeniaWLokalizacjiComponent[]): Uszkodzenie<N>[] {
    return uszkodzenia
      .filter((element) => (element.wszystkieWartosciWypelnione() || element.formularzUszkodzenia.valid) &&
        Object.keys(element.formularzUszkodzenia.controls).filter(n => n.includes('_group')).length === 0)
      .map((element) => {
        const parametryUszkodzenia = {} as N
        return element.utworzObiektUszkodzenia(parametryUszkodzenia)
      });
  }

  protected utworzUszkodzeniaGrupowe<N extends ParametryUszkodzen>(uszkodzenia: UszkodzeniaWLokalizacjiComponent[]): Uszkodzenie<N>[] {
    return uszkodzenia.filter((element) => (element.wszystkieWartosciWypelnione() || element.formularzUszkodzenia.valid)
      && Object.keys(element.formularzUszkodzenia.controls)
        .filter(n => n.includes('_group')).length > 0).flatMap(element => ({
      element,
      params: element.uszkodzeniaGrupowe.map(f => (f.getUszkodzenia<N>())).flatMap(u => u),
    }))
      .map(({element, params}) => {
        return params.map((param) => ({lokalizacjaComponent: element, parametryUszkodzenia: param.value, id: param.id}))
          .map(({lokalizacjaComponent, parametryUszkodzenia, id}) => (lokalizacjaComponent.utworzObiektUszkodzenia(parametryUszkodzenia, id)))
      }).flatMap(u => u);
  }

  protected utworzUszkodzeniaPojedynczeDlaPrzedmiotowSzklanych<N extends ParametryUszkodzen>(uszkodzenia: UszkodzeniaWLokalizacjiComponent[]): Uszkodzenie<ParametryPrzedmiotuSzklanego>[] {
    return uszkodzenia
      .filter((element) => (element.wszystkieWartosciWypelnione() || element.formularzUszkodzenia.valid) &&
        Object.keys(element.formularzUszkodzenia.controls).filter(n => n.includes('_group')).length === 0)
      .map((element) => {
        const parametryUszkodzenia = {} as ParametryPrzedmiotuSzklanego
        parametryUszkodzenia.komentarz = element.wartoscFormularza(element.KOMENTARZ_USZKODZENIA_FORM_FIELD);
        return element.utworzObiektUszkodzenia(parametryUszkodzenia)
      });
  }

  private save(zbiorUszkodzen: ZbiorUszkodzen): void {
    this.store.dispatch(aktualizujZbiorUszkodzen({przedmiotId: this.idPrzedmiotuUbezpieczenia, zbiorUszkodzen}))
  }

  private generateUuId(): string {
    return uuidv4();
  }

  protected getFormControlWithDateValidation(param: YearMonth | null): FormControl<YearMonth | null> {
    return new FormControl<YearMonth | null>(param, [
      Validators.required,
      isDateFilled(),
    ]);
  }

  protected getFormControlWithStoreyValidation(param: number | null): FormControl<number | null> {
    return new FormControl<number | null>(param, [
      Validators.required,
      min(this.MIN_VALUE),
      max(this.MAX_VALUE),
      isInteger()
    ]);
  }

  czyFormularzLokalizacjiUszkodzeniaPoprawny(): boolean {
    return !this.formularzLokalizacjiUszkodzenia ? true : this.formularzLokalizacjiUszkodzenia.valid;
  }
}
